export const RoleTypeFunctionInfo = [
  { id: "character_instrument", name: "배역 악기 (character_instrument)" },
  { id: "single_instrument", name: "단수 악기 (single_instrument)" },
  { id: "instrument_superset", name: "악기 집합 (instrument_superset)" },
  { id: "ensemble_instrument", name: "앙상블 (ensemble_instrument)" }
];
